// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/pursuit_open.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureProject } from "./capture_pb";
/**
 * @generated from message mono.datagateway.v1.OpenPursuitRequest
 */ export class OpenPursuitRequest extends Message {
    static fromBinary(bytes, options) {
        return new OpenPursuitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenPursuitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenPursuitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenPursuitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * required; caller-minted, one per deliberate open
   *
   * @generated from field: string opening_request_id = 2;
   */ _define_property(this, "openingRequestId", ""), /**
   * optional; the canonical Opportunity
   *
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * optional; no referential check (SAD-479)
   *
   * @generated from field: string qualification_id = 4;
   */ _define_property(this, "qualificationId", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string zou_project_id = 6;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string account_id = 7;
   */ _define_property(this, "accountId", ""), /**
   * @generated from field: string customer_org_id = 8;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string opportunity_hypothesis = 9;
   */ _define_property(this, "opportunityHypothesis", ""), /**
   * optional; SAD-480 selective Qualification handoff
   *
   * @generated from field: mono.datagateway.v1.QualificationHandoff handoff = 10;
   */ _define_property(this, "handoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenPursuitRequest, "runtime", proto3);
_define_property(OpenPursuitRequest, "typeName", "mono.datagateway.v1.OpenPursuitRequest");
_define_property(OpenPursuitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opening_request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "qualification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "account_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "opportunity_hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "handoff",
            kind: "message",
            T: QualificationHandoff
        }
    ]));
/**
 * QualificationHandoff carries chosen context from a "pursue" Qualification
 * into the new Pursuit. Applied once, when the Pursuit is created.
 *
 * @generated from message mono.datagateway.v1.QualificationHandoff
 */ export class QualificationHandoff extends Message {
    static fromBinary(bytes, options) {
        return new QualificationHandoff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QualificationHandoff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QualificationHandoff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QualificationHandoff, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evaluation_id = 1;
   */ _define_property(this, "evaluationId", ""), /**
   * "rationale" or "answer:<criterion id>"; unlisted context does not carry.
   *
   * @generated from field: repeated string selected_keys = 2;
   */ _define_property(this, "selectedKeys", []), /**
   * set by zou from the principal
   *
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QualificationHandoff, "runtime", proto3);
_define_property(QualificationHandoff, "typeName", "mono.datagateway.v1.QualificationHandoff");
_define_property(QualificationHandoff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "selected_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpenPursuitResponse
 */ export class OpenPursuitResponse extends Message {
    static fromBinary(bytes, options) {
        return new OpenPursuitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenPursuitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenPursuitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenPursuitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProject capture_project = 1;
   */ _define_property(this, "captureProject", void 0), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string qualification_id = 3;
   */ _define_property(this, "qualificationId", ""), /**
   * false when opening_request_id was a retry
   *
   * @generated from field: bool created = 4;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenPursuitResponse, "runtime", proto3);
_define_property(OpenPursuitResponse, "typeName", "mono.datagateway.v1.OpenPursuitResponse");
_define_property(OpenPursuitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project",
            kind: "message",
            T: CaptureProject
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "qualification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPursuitOpeningRequest
 */ export class GetPursuitOpeningRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitOpeningRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitOpeningRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitOpeningRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitOpeningRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitOpeningRequest, "runtime", proto3);
_define_property(GetPursuitOpeningRequest, "typeName", "mono.datagateway.v1.GetPursuitOpeningRequest");
_define_property(GetPursuitOpeningRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPursuitOpeningResponse
 */ export class GetPursuitOpeningResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitOpeningResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitOpeningResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitOpeningResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitOpeningResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string qualification_id = 2;
   */ _define_property(this, "qualificationId", ""), /**
   * @generated from field: string opening_request_id = 3;
   */ _define_property(this, "openingRequestId", ""), /**
   * @generated from field: mono.datagateway.v1.QualificationHandoffSnapshot qualification_handoff = 4;
   */ _define_property(this, "qualificationHandoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitOpeningResponse, "runtime", proto3);
_define_property(GetPursuitOpeningResponse, "typeName", "mono.datagateway.v1.GetPursuitOpeningResponse");
_define_property(GetPursuitOpeningResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "qualification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opening_request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "qualification_handoff",
            kind: "message",
            T: QualificationHandoffSnapshot
        }
    ]));
/**
 * Immutable selected context only. Never populated from live evaluation answers.
 *
 * @generated from message mono.datagateway.v1.QualificationHandoffSnapshot
 */ export class QualificationHandoffSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new QualificationHandoffSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QualificationHandoffSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QualificationHandoffSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QualificationHandoffSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * selected handoff items with per-item provenance and answer basis
   *
   * @generated from field: string context_json = 1;
   */ _define_property(this, "contextJson", ""), /**
   * @generated from field: string evaluation_id = 2;
   */ _define_property(this, "evaluationId", ""), /**
   * @generated from field: string source_event_id = 3;
   */ _define_property(this, "sourceEventId", ""), /**
   * @generated from field: string handoff_event_id = 4;
   */ _define_property(this, "handoffEventId", ""), /**
   * @generated from field: string template_version_id = 5;
   */ _define_property(this, "templateVersionId", ""), /**
   * @generated from field: int32 template_version = 6;
   */ _define_property(this, "templateVersion", 0), /**
   * actor of the originating disposition
   *
   * @generated from field: string reviewer = 7;
   */ _define_property(this, "reviewer", ""), /**
   * actor who selected the handoff
   *
   * @generated from field: string actor = 8;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string disposition = 10;
   */ _define_property(this, "disposition", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QualificationHandoffSnapshot, "runtime", proto3);
_define_property(QualificationHandoffSnapshot, "typeName", "mono.datagateway.v1.QualificationHandoffSnapshot");
_define_property(QualificationHandoffSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "handoff_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "template_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "template_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "reviewer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "disposition",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
